function removeOuterParens(text) {
  let str = text
  while (/^\((.+)\)$/.test(str)) {
    let depth = 0
    let isWrapping = true
    for (let i = 0; i < str.length; i += 1) {
      // eslint-disable-next-line security/detect-object-injection
      if (str[i] === '(') depth += 1
      // eslint-disable-next-line security/detect-object-injection
      if (str[i] === ')') depth -= 1
      if (depth === 0 && i < str.length - 1) {
        isWrapping = false
        break
      }
    }
    if (isWrapping) str = str.slice(1, -1)
    else break
  }
  return str
}

function cleanParts(expr) {
  return expr.split(/\bOR\b/).map(part => removeOuterParens(part.trim())).join(' OR ')
}

export function transformExpression(input) {
  let index = 0
  const result = []

  const cleanedInput = removeOuterParens(input)

  function splitByTopLevelAND(expr) {
    const parts = []
    let bracketCount = 0
    let start = 0

    for (let i = 0; i < expr.length; i++) {
      // eslint-disable-next-line security/detect-object-injection
      if (expr[i] === '(') bracketCount += 1
      // eslint-disable-next-line security/detect-object-injection
      else if (expr[i] === ')') bracketCount -= 1

      if (bracketCount === 0 && expr.slice(i, i + 5) === ' AND ') {
        parts.push(expr.slice(start, i).trim())
        start = i + 5
        i += 4
      }
    }

    parts.push(expr.slice(start).trim())
    return parts
  }

  function highlightOR(expr) {
    return expr.replace(/\bOR\b/g, '<span class="or-divider">OR</span>')
  }

  const expressions = splitByTopLevelAND(cleanedInput)

  for (const exp of expressions) {
    const cleaned = cleanParts(removeOuterParens(exp))
    const highlighted = highlightOR(cleaned)
    result.push(
      `<div class="line">
        <span class="number">
            ${ index += 1 }
        </span>
        <span class="content">
            + ${ highlighted }
        </span>
      </div>`
    )
  }

  return result.join('\n')
}

export function transformSimilarResults(input) {
  if (!input) return ''

  const result = []
  const expressions = []

  const cleanedInput = removeOuterParens(input)

  function splitByTopLevelAND(expr) {
    const parts = []
    let bracketCount = 0
    let start = 0

    for (let i = 0; i < expr.length; i++) {
      // eslint-disable-next-line security/detect-object-injection
      if (expr[i] === '(') bracketCount += 1
      // eslint-disable-next-line security/detect-object-injection
      else if (expr[i] === ')') bracketCount -= 1

      if (bracketCount === 0 && expr.slice(i, i + 5) === ' AND ') {
        parts.push(expr.slice(start, i).trim())
        start = i + 5
        i += 4
      }
    }

    parts.push(expr.slice(start).trim())
    return parts
  }

  function highlightOR(expr) {
    return expr.replace(/\bOR\b/g, '<span class="or-divider">OR</span>')
  }

  const expressionParts = splitByTopLevelAND(cleanedInput)

  for (const exp of expressionParts) {
    const cleaned = cleanParts(removeOuterParens(exp))
    expressions.push(cleaned)
    const highlighted = highlightOR(cleaned)
    result.push(
      `<div class="line">
        <span class="content">
            + ${ highlighted }
        </span>
      </div>`
    )
  }

  return {
    expressions,
    formattedExplanation: result.join('\n')
  }
}
